import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { parseLocalePath, getLocaleMeta } from "@/i18n/config";

/**
 * Watches the URL, extracts the locale segment, and syncs
 * i18next language + <html lang> + <html dir> accordingly.
 * English URLs have no prefix. Non-default locales are `/xx/...`.
 */
export default function LocaleSync() {
    const { pathname } = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        const { locale } = parseLocalePath(pathname);
        const meta = getLocaleMeta(locale);
        if (i18n.language !== locale) i18n.changeLanguage(locale);
        document.documentElement.lang = locale;
        document.documentElement.dir = meta.rtl ? "rtl" : "ltr";
    }, [pathname, i18n]);

    return null;
}
